<div class="skeleton-card">
  <div class="skeleton-card__header">
    <div class="skeleton skeleton--text short"></div>
    <div class="skeleton skeleton--avatar"></div>
  </div>
  <div class="skeleton skeleton--image"></div>
  <div class="skeleton skeleton--text short"></div>
  <div class="skeleton skeleton--text"></div>
  <div class="skeleton skeleton--text"></div>
</div>
